import { RoutePoint } from 'common/utils/directionsService/types';

export const getRouteAddress = (routePoint: RoutePoint): string => (
  routePoint.value || ''
);
